const getters = {
    userInfo: state => state.user.userInfo,
    companyinfo: state => state.show.companyinfo
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js